import { operatorApiFetch } from './apiService';

export const shelfTypeService = {
  // 取得所有 (不分頁)
  listAll: async () => {
    const response = await operatorApiFetch('shelf_types/list_all', {
      method: 'GET'
    });
    return response.json();
  },

  // 取得列表（用於表格）
  fetchList: async () => {
    const res = await operatorApiFetch('shelf_types', {
      method: 'GET'
    });
    return res.json();
  },

  // 取得單筆
  get: async (id) => {
    const res = await operatorApiFetch(`shelf_types/${id}`, {
      method: 'GET'
    });
    return res.json();
  },

  // 新增
  create: async (data) => {
    const res = await operatorApiFetch('shelf_types', {
      method: 'POST',
      body: { shelf_type: data }
    });
    return res.json();
  },

  // 更新
  update: async (id, data) => {
    const res = await operatorApiFetch(`shelf_types/${id}`, {
      method: 'PUT',
      body: { shelf_type: data }
    });
    return res.json();
  },

  // 刪除
  delete: async (id, replacementId = null) => {
    const url = replacementId ? `shelf_types/${id}?replacement_id=${replacementId}` : `shelf_types/${id}`;
    const res = await operatorApiFetch(url, {
      method: 'DELETE'
    });
    return res.json();
  }
};

export default shelfTypeService;
